/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelBookingViaLinkPayload } from '../models/CancelBookingViaLinkPayload';
import type { ClientRegistrationActionPayload } from '../models/ClientRegistrationActionPayload';
import type { LinkActionResponse } from '../models/LinkActionResponse';
import type { LinkData } from '../models/LinkData';
import type { LinkLayoutContext } from '../models/LinkLayoutContext';
import type { MoveBookingViaLinkPayload } from '../models/MoveBookingViaLinkPayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LinkService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get link layout context
     * Layout shell context for link.tebuto.de (header/footer branding)
     * @param linkId
     * @returns LinkLayoutContext
     * @throws ApiError
     */
    public getLinkLayoutContext(
        linkId: string,
    ): CancelablePromise<LinkLayoutContext> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/link/layout-context/{linkId}',
            path: {
                'linkId': linkId,
            },
        });
    }
    /**
     * Get assignment preview without processing
     * Get assignment preview for a link
     * @param id
     * @returns any
     * @throws ApiError
     */
    public getAssignmentPreview(
        id: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/link/{id}/assignment-preview',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get booking-management preview
     * Get a booking-management preview for a magic link (booking details + allowed actions)
     * @param id
     * @returns any
     * @throws ApiError
     */
    public getBookingManagementPreview(
        id: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/link/{id}/booking-management-preview',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Cancel a booking via magic link
     * Cancel a booking via its magic link
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public cancelBookingViaLink(
        id: string,
        requestBody: CancelBookingViaLinkPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/link/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reschedule a booking via magic link
     * Reschedule (move) a booking via its magic link
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public moveBookingViaLink(
        id: string,
        requestBody: MoveBookingViaLinkPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/link/{id}/move',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Submit a form via magic link
     * Submit a filled form via its magic link
     * @param id
     * @param formData
     * @returns any
     * @throws ApiError
     */
    public submitFormViaLink(
        id: string,
        formData: Record<string, Blob>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/link/{id}/submit-form',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get Link Data
     * Get Link Data
     * @param id
     * @returns LinkData
     * @throws ApiError
     */
    public getLinkData(
        id: string,
    ): CancelablePromise<LinkData> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/link/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Handle Link Action
     * Handle Link Action
     * @param id
     * @param requestBody
     * @returns LinkActionResponse
     * @throws ApiError
     */
    public handleLinkAction(
        id: string,
        requestBody: ClientRegistrationActionPayload,
    ): CancelablePromise<LinkActionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/link/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate PayPal client token
     * Generate PayPal client token for assignment payment
     * @param id
     * @returns any
     * @throws ApiError
     */
    public getAssignmentPayPalClientToken(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/link/{id}/paypal/client-token',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create PayPal order
     * Create PayPal order for assignment payment
     * @param id
     * @returns any
     * @throws ApiError
     */
    public createAssignmentPayPalOrder(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/link/{id}/paypal/create-order',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Capture PayPal order
     * Capture PayPal order for assignment payment
     * @param id
     * @param orderId
     * @returns any
     * @throws ApiError
     */
    public captureAssignmentPayPalOrder(
        id: string,
        orderId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/link/{id}/paypal/capture-order/{orderId}',
            path: {
                'id': id,
                'orderId': orderId,
            },
        });
    }
    /**
     * Create Stripe checkout session
     * Create Stripe checkout session for assignment payment
     * @param id
     * @returns any
     * @throws ApiError
     */
    public createAssignmentStripeCheckoutSession(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/link/{id}/stripe/create-checkout-session',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Confirm Stripe checkout session
     * Confirm Stripe checkout session for assignment payment
     * @param id
     * @param checkoutSessionId
     * @returns any
     * @throws ApiError
     */
    public confirmAssignmentStripeCheckoutSession(
        id: string,
        checkoutSessionId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/link/{id}/stripe/confirm-checkout-session/{checkoutSessionId}',
            path: {
                'id': id,
                'checkoutSessionId': checkoutSessionId,
            },
        });
    }
}
